import styled from 'styled-components';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Close as CloseIcon } from '@material-ui/icons';
import { Dialog } from '@material-ui/core';
import { Container, palette } from '@dev/ee-components';

import { useMobile } from '@/services/hooks/useMobile';
import { ClearViewEmail, ViewEmailStart } from '@/store/emails/actions';

import Attachments from './Attachments';
import EmailInfoRows from './EmailInfoRows';
import EmailWraper from './EmailWraper';
import EventHistoryChart from './EventHistoryChart';
import Header from './Header';
import { ViewEmailProps } from './ViewEmailProps';

const CloseIconContainer = styled.div`
    width: 100%;
    height: 68px;
    svg {
        top: 24px;
        right: 24px;
        position: absolute;
        cursor: pointer;
    }
`;

type BoardProps = {
    isMobile: boolean;
};

const Board = styled.div<BoardProps>`
    padding: ${(props) => (props.isMobile ? '24px 20px' : '24px 48px')};
    border: 1px solid ${palette.gray[3]};
    border-radius: 4px;
`;

const ScreenContainer = styled.div`
    & iframe {
        margin-top: 32px;
        width: 100%;
        height: 520px;
        border: 0;
        border-radius: 4px 0 0 4px;
    }
`;

const ViewEmail = (props: ViewEmailProps): JSX.Element => {
    const dispatch = useDispatch();
    const isMobile = useMobile();
    const { msgId, open, onClose } = props;

    useEffect(() => {
        dispatch(ViewEmailStart(msgId));
        return () => {
            dispatch(ClearViewEmail());
        };
    }, []);

    return (
        <Dialog fullScreen open={open} onClose={onClose}>
            <CloseIconContainer>
                <CloseIcon onClick={onClose} />
            </CloseIconContainer>
            <Container variant="basic" padding={{ top: 76 }}>
                <ScreenContainer>
                    <Header />
                    <Board isMobile={isMobile}>
                        <EmailInfoRows msgId={msgId} />
                        <Attachments />
                        {!props.isSmsScreen && <EventHistoryChart />}
                    </Board>
                    {!props.isNotificationLog && <EmailWraper />}
                </ScreenContainer>
            </Container>
        </Dialog>
    );
};

export default ViewEmail;
